import { IconButton, styled } from "@mui/material"

const sizes = {
    small: 32,
    medium: 40,
    large: 48,
}

const backgroundColors = (theme) => ({
    disabled: theme.palette["action/disabledBackground"].main,
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    tertiary: "transparent",
})

const colors = (theme) => ({
    disabled: theme.palette["action/disabled"].main,
    primary: theme.palette.primary.contrastText,
    secondary: theme.palette.secondary.contrastText,
    tertiary: theme.palette["action/active"].main,
})

const hoverColors = (theme) => ({
    primary: theme.palette.primary.dark,
    secondary: theme.palette.secondary.dark,
    tertiary: theme.palette["action/selected"].main,
})

export const FilledIconButton = styled(IconButton, { shouldForwardProp: (prop) => prop !== "color" && prop !== "size" })(({ disabled, theme, color, size }) => {
    const currentColor = disabled ? "disabled" : color
    return ({
        backgroundColor: `${backgroundColors(theme)[currentColor] || backgroundColors(theme).primary} !important`,
        color: colors(theme)[currentColor] || colors(theme).primary,
        borderRadius: 9999,
        width: sizes[size],
        height: sizes[size],

        "&:hover": {
            backgroundColor: hoverColors(theme)[currentColor] || hoverColors(theme).primary,
        },
    })
})